import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'reactstrap';
import { FooterElement, FooterSectionContent, FooterSectionHeader, FooterSectionTop, FooterSectionList, FooterCopyright, FooterSection } from './FooterElements';
import { optionsFor as getOptionsFor, footerOptions as defaultFooterOptions } from './footerOptions';
import { last } from 'ramda';

var isArray = Array.isArray;

var FooterComp = function FooterComp(_ref) {
  var sections = _ref.sections,
      copyright = _ref.copyright;
  return React.createElement(
    FooterElement,
    null,
    React.createElement(
      Container,
      null,
      React.createElement(
        Row,
        null,
        sections.map(function (_ref2) {
          var id = _ref2.id,
              title = _ref2.title,
              options = _ref2.options;
          return React.createElement(
            FooterSection,
            { key: id },
            React.createElement(
              FooterSectionTop,
              null,
              React.createElement(
                FooterSectionHeader,
                null,
                title
              ),
              React.createElement(
                FooterSectionContent,
                null,
                isArray(options) ? React.createElement(FooterSectionList, { list: options }) : options
              )
            ),
            last(sections).id === id ? React.createElement(
              FooterCopyright,
              null,
              copyright
            ) : null
          );
        })
      )
    )
  );
};

FooterComp.displayName = 'PGAFooter';
FooterComp.propTypes = process.env.NODE_ENV !== "production" ? {
  sections: PropTypes.array.isRequired,
  copyright: PropTypes.string
} : {};

export var optionsFor = getOptionsFor;

export var footerOptions = defaultFooterOptions;

export var Footer = FooterComp;